<script setup lang="ts">
import GoogleReviewsIcon from '@/components/ItemRating/GoogleReviewsIcon.vue';
import TripAdvisorIcon from '@/components/ItemRating/TripAdvisorIcon.vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import { type ItemRating, ItemRatingProvider } from '@/types';

interface ItemListRatingProps {
  rating: ItemRating;
}

defineProps<ItemListRatingProps>();
</script>

<template>
  <div>
    <BaseFlexbox direction="row" align-items="center" gap="1">
      <GoogleReviewsIcon
        v-if="rating.provider === ItemRatingProvider.GOOGLE_REVIEWS"
      />
      <TripAdvisorIcon
        v-if="rating.provider === ItemRatingProvider.TRIP_ADVISOR"
      />
      <div class="text-gray-800 text-sm">{{ rating.rating }}</div>
    </BaseFlexbox>
    <div class="text-gray-500 text-sm">
      {{ rating.reviewCount }}
      {{ rating.reviewCount === 1 ? 'review' : 'reviews' }}
    </div>
  </div>
</template>
